import { APP_CONFIG } from '../../shared/config/app.config';
import { AuthService } from '../../auth/services/authService';
import type {
  Ticket,
  TicketStatus,
  CreateTicketPayload,
} from '../types/ticket';

const BASE = APP_CONFIG.API.BASE_URL;

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const token = AuthService.getToken();
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status} — ${body || res.statusText}`);
  }
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}

export const TicketsService = {
  mine(): Promise<Ticket[]> {
    return call('/tickets/mine');
  },

  listAll(status?: TicketStatus): Promise<Ticket[]> {
    return call(`/tickets${status ? `?status=${status}` : ''}`);
  },

  create(payload: CreateTicketPayload): Promise<Ticket> {
    return call('/tickets', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  updateStatus(
    id: string,
    status: TicketStatus,
    resolutionNotes?: string,
  ): Promise<Ticket> {
    return call(`/tickets/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status, resolutionNotes }),
    });
  },
};
